import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import './ReversoPisoSpcPremium.css';

window.$ = window.jQuery = $;

require('owl.carousel/dist/assets/owl.carousel.css');
require('owl.carousel/dist/assets/owl.theme.default.css');
require('owl.carousel');

const ReversoPisoSpcPremium = () => {
  const [carouselInitialized, setCarouselInitialized] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      const $carousel = $('.reverso-carousel');

      if ($carousel.length && !carouselInitialized) {
        try {
          $carousel.owlCarousel({
            items: 1,
            loop: true,
            nav: false,
            dots: true,
            autoplay: true,
            autoplayTimeout: 4000,
            autoplayHoverPause: true,
            smartSpeed: 700,
            responsive: {
              0: { items: 1, dots: true },
              768: { items: 1, dots: true },
              1024: { items: 1, dots: true },
            },
          });
          setCarouselInitialized(true);
        } catch (error) {
          console.error('Error initializing carousel:', error);
        }
      }
    }, 100);

    return () => {
      clearTimeout(timer);
      try {
        const $carousel = $('.reverso-carousel');
        if ($carousel.length && carouselInitialized) {
          $carousel.trigger('destroy.owl.carousel');
          setCarouselInitialized(false);
        }
      } catch (error) {
        console.error('Error destroying carousel:', error);
      }
    };
  }, [carouselInitialized]);

  return (
    <section className="reverso-piso-section py-5 py-lg-7">
      <div className="container">
        <div className="row align-items-center gap-3 gap-lg-0">

          {/* Columna Carrusel */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="reverso-carousel-wrapper wow fadeInLeft" data-wow-delay="200ms">
              <div className="reverso-carousel owl-carousel owl-theme">
                <div className="item">
                  <img
                    src="/assets/img/productos/pisos-spc-premium/carrusel_reves/carrusel_1.jpeg"
                    alt="Reverso Piso SPC Premium - Vista 1"
                  />
                </div>
                <div className="item">
                  <img
                    src="/assets/img/productos/pisos-spc-premium/carrusel_reves/carrusel_2.jpeg"
                    alt="Reverso Piso SPC Premium - Vista 2"
                  />
                </div>
                <div className="item">
                  <img
                    src="/assets/img/productos/pisos-spc-premium/carrusel_reves/carrusel_3.jpeg"
                    alt="Reverso Piso SPC Premium - Vista 3"
                  />
                </div>
                <div className="item">
                  <img
                    src="/assets/img/productos/pisos-spc-premium/carrusel_reves/carrusel_4.jpeg"
                    alt="Reverso Piso SPC Premium - Vista 4"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Columna Texto */}
          <div className="col-lg-6">
            <div className="reverso-content wow fadeInRight" data-wow-delay="300ms">
              <div className="mb-3 title-style5">
                <h2 className="h1 font-weight-800 mb-0">
                  Sistema de ensamblado del Piso SPC Luxury
                </h2>
              </div>

              <p className="mb-4 opacity9 fs-18">
                Cada detalle del Piso SPC Luxury está pensado para instalarse fácilmente y ofrecer comodidad y durabilidad.
              </p>

              <div className="reverso-benefits">
               {/* Bullet Unilin Click */}
                <div className="benefit-item benefit-item--unilin mb-3">
                  <div className="d-flex align-items-start">
                    <span className="benefit-icon me-3">
                      <i className="fa-solid fa-puzzle-piece"></i>
                    </span>
                    <div>
                      <h4 className="mb-1">
                        Sistema de Ensamblado{' '}
                        <span className="unilin-inline-badge">Unilin Click</span>
                      </h4>
                      <p className="mb-0 opacity7">
                        Tecnología de bloqueo que une cada panel con
                        un clic seguro. Permite instalación rápida y desmontaje sencillo.
                      </p>
                    </div>
                  </div>
                </div>
                
               <div className="benefit-item mb-3">
                  <div className="d-flex align-items-start">
                    <span className="benefit-icon me-3">
                      <i className="fa-solid fa-shoe-prints"></i>
                    </span>
                    <div>
                      <h4 className="mb-1">Base Acolchada Integrada</h4>
                      <p className="mb-0 opacity7">
                        Proporciona comodidad al caminar con una superficie suave
                        y absorbente bajo cada paso.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="benefit-item mb-3">
                  <div className="d-flex align-items-start">
                    <span className="benefit-icon me-3">
                      <i className="fa-solid fa-temperature-half"></i>
                    </span>
                    <div>
                      <h4 className="mb-1">Barrera Térmica</h4>
                      <p className="mb-0 opacity7">
                        Mejora el aislamiento térmico del piso, ideal para
                        superficies frías o climas extremos.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="benefit-item mb-3">
                  <div className="d-flex align-items-start">
                    <span className="benefit-icon me-3">
                      <i className="fa-solid fa-volume-xmark"></i>
                    </span>
                    <div>
                      <h4 className="mb-1">Reducción de Ruido</h4>
                      <p className="mb-0 opacity7">
                        Aislamiento acústico superior que absorbe el impacto
                        de los pasos y reduce la transmisión de sonido.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

             {/*
              <div className="mt-4">
                <a href="contacto-decototal" className="butn-style7 rounded">
                  Obtén Más Información
                </a>
              </div>
              */}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ReversoPisoSpcPremium;